export { default } from "bullitttime-embermodelsevent/adapters/segment";
